module.exports = __webpack_public_path__ + "static/media/maw.43c6abc2.svg";